export default __webpack_public_path__ + "static/media/logo.31ee3a6f.svg";